import type { Component } from 'vue';
import type { TemplateType } from '..';
import SchemaPage from './SchemaPage.vue';
import SchemaPageItem from './SchemaPageItem.vue';

/** schema渲染模板组件 */
const CFRenderComp = new Map<TemplateType, Component>();
CFRenderComp.set('LIST_PAGE', SchemaPage);
CFRenderComp.set('PAGE_ITEM', SchemaPageItem);
export { CFRenderComp };
